import { render } from "./formrichtext.vue?vue&type=template&id=3af0b56a"
import script from "./formrichtext.vue?vue&type=script&lang=js"
export * from "./formrichtext.vue?vue&type=script&lang=js"

import "./formrichtext.vue?vue&type=style&index=0&id=3af0b56a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__